import { styled } from '@mui/material';
import { Button } from 'react-bootstrap';

export const CustomButton = styled(Button)`
  background-color: #5650bf;
  padding: 16px 40px;
  border-radius: 6px;
  border: none;

  &:hover,
  &:active,
  &:focus {
    background-color: #453fa4;
  }
`;
